/* eslint-disable @typescript-eslint/no-explicit-any */
import type { SpinProps } from "ant-design-vue";

import type { UploadFile } from "ant-design-vue";

type TrustConfig = {
  escrowCode?: string;
  hoster?: string;
  hosterName?: string;
  uploadUrl?: string;
  encryptionFile?: UploadFile[];
  trustHosterInfo?: {
    dataName: string;
    dataHash: string;
    hosterName: string;
    trustPrice: string;
    datasetId: number;
    metaJson: string;
  };
};

export interface ConfigState {
  spinConfig: SpinProps;
  encryptionConfig: {
    privateKey: string;
    publicKey: string;
    metaKeyFileName: string;
    proofStatus?: 1 | 2;
    metaFile?: {
      path: string;
      type?: "csv" | "excel";
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fieldInfo?: any[];
    fileName?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    sealedFile?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metaJsonFile?: any;
    isDownloadFile: boolean;
    sealedFilePath?: string;
  };
  trustConfig: TrustConfig;
  publishDataConfig: {
    selectFile?: {
      name: string;
      size: number;
      type: string;
      path: string;
    };
    editDataInfo?: {
      datasetName: string;
      price?: number;
      tag?: string;
      pattern?: string;
      intro?: string;
      descriptionTxt?: string;
      auditType: 0 | 1;
      serverType: 0 | 1;
      serverUrl?: string;
      serverPublicKey?: string;
      imageList?: {
        imageUrl: string;
        imageOrder: number;
      }[];
      rcrFromSeller?: number;
    };
    selectAlgorithm?: {
      algorithmList?: {
        id: number;
        hash: string;
        [x: string]: any;
      }[];
      privateKey: string;
      isEmpower: boolean;
    };
  };
  publishAPIDataConfig: {
    editAPIDataInfo?: {
      apiName: string;
      price?: number;
      tag?: string;
      description?: string;
      descriptionTxt?: string;
      imageList?: {
        imageUrl: string;
        imageOrder: number;
      }[];
    };
    editAPIDataConfigInfo?: {
      datasetId: number;
    };
  };
}

export const state: ConfigState = {
  spinConfig: {
    spinning: false,
    tip: "Loading...",
    size: "large",
  },
  encryptionConfig: {
    privateKey: "",
    publicKey: "",
    metaKeyFileName: "",
    isDownloadFile: false,
  },
  trustConfig: {},
  publishDataConfig: {},
  publishAPIDataConfig: {},
};
